import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['message']

  connect() {
    // Auto-dismiss after 5 seconds
    this.autoDismissTimeout = setTimeout(() => {
      this.dismissAll()
    }, 5000)
  }

  disconnect() {
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout)
    }
  }

  dismiss(event) {
    const message = event.target.closest('[data-dashboard--flash-target="message"]')
    if (message) {
      this.fadeOut(message)
    }
  }

  dismissAll() {
    this.messageTargets.forEach((message) => {
      this.fadeOut(message)
    })
  }

  fadeOut(element) {
    element.style.transition = 'opacity 300ms ease-out, transform 300ms ease-out'
    element.style.opacity = '0'
    element.style.transform = 'translateX(20px)'

    setTimeout(() => {
      element.remove()

      // Remove the container if no more messages
      if (this.messageTargets.length === 0 && this.element) {
        this.element.remove()
      }
    }, 300)
  }
}
